import { MuiInput } from "./../components/basicComponent/MuiInput";
import Header from "./../sharedScreens/Header";
// import Textarea from '@mui/joy/Textarea';
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import React, { useState } from "react";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import MuiUploader from "./../components/basicComponent/MuiUploader";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { FastField } from "formik";

const AgentCreation = () => {
  const [active, setActive] = useState<Boolean>(false);
  const agents = [
    {
      slNo: 1,
      agentId: "ESAUH0000101",
      agentName: "QAD AGENCY",
      salesPerson: "Tesepr",
      landline: "",
      mobile: "7010180039",
      email: "Sujhaudeen.Sts@Gm...",
      joinedDate: "20/11/2024",
      updatedBy: "Tesepr - 20/11/2024 17...",
      balance: "0.00",
      agentType: "SubAgent",
      status: "Active",
    },
  ];

  const [open, setOpen] = React.useState(true);
  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1 managebookingg">
                <h3 className="card-title titlecolorr"> {active ? "Agent View Details" : "Agent Creation"}</h3>
                <button
                  className="fliter-btn"
                  onClick={() => {
                    setActive(!active);
                  }}
                >
                  {/* <span>Agent Creation</span> */}
                  {active ? "View Details" : " Agent Creation"}
                </button>
              </div>
              <div className="card changepass-card">
                <div className="card-body mt-4">
                  {active && (
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Agent Name"
                          label={"Agent Name"}
                          isRequired={true}
                        />
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 mb-3">
                        <MuiDropDown
                          placeholder="Branch"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                        <MuiDropDown
                          placeholder="Title "
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-xl-5 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="First Name"
                          label={"First Name"}
                          isRequired={true}
                        />
                      </div>
                      <div className="col-xl-5 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Last Name"
                          label={"Last Name"}
                          isRequired={true}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <textarea
                          id="message"
                          name="message"
                          rows={5}
                          cols={60}
                          style={{ width: "100%" }}
                          placeholder="Address"
                        ></textarea>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Primary Email-id"
                          label={"Primary Email-id"}
                          isRequired={true}
                        />
                        <div className="row">
                          <div className="col-xl-12 col-lg-4 col-md-6 my-3">
                            <MuiInput
                              placeholder="Email-id Alternate"
                              label={"Email-id Alternate"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Contact Number"
                          label={"Contact Number"}
                          isRequired={true}
                        />
                        <div className="row">
                          <div className="col-xl-12 col-lg-4 col-md-6 my-3">
                            <MuiInput
                              placeholder="Landline Number"
                              label={"Landline Number"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiUploader
                          label="Trade License No-P1"
                          name="documentProofTradeLicense"
                          values={""}
                          errors={""}
                        />
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiUploader
                          label="Emirates Id-P2"
                          name="documentProofTradeLicense"
                          values={""}
                          errors={""}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiUploader
                          label="Txn. No-P3"
                          name="documentProofTradeLicense"
                          values={""}
                          errors={""}
                        />
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiDatePicker
                          label=" Trade License Exp Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiDatePicker
                          label=" Emirates Id Exp Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiDatePicker
                          label=" Txn. No Exp Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Postal Code"
                          label={"Postal Code"}
                          isRequired={true}
                        />
                      </div>

                      <div className="col-md-3">
                        <MuiSearchSelect
                          label="Country"
                          placeholder={""}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-3">
                        <MuiInput
                          label={"Accounts Ref.ID"}
                          placeholder="Accounts Ref.ID"
                        />
                      </div>
                      <div className="col-md-3">
                        <MuiSearchSelect
                          label="Sales Incharge"
                          placeholder={"Sales Incharge"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="row mt-3">
                        <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                          Agent Information
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                            height: "164px",
                          }}
                        >
                          <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                              <MuiUploader
                                label="File"
                                name="documentProofTradeLicense"
                                values={""}
                                errors={""}
                              />

                              <div className="row">
                                <div className="col-12 mt-2">
                                  <Alert
                                    icon={false}
                                    severity="error"
                                    sx={{
                                      backgroundColor: "#fff5f5", // Light red background
                                      color: "#d32f2f", // Red text
                                      borderRadius: "8px", // Rounded corners
                                      border: "1px solid #f5c6cb", // Light red border
                                    }}
                                  >
                                    <Typography variant="body2">
                                      Vertical - Min 80W X 60H & Max 104W X 112H
                                    </Typography>
                                    <Typography variant="body2">
                                      Horizontal - Min 120W X 40H & Max 220W X
                                      60H
                                    </Typography>
                                  </Alert>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-8 col-lg-4 col-md-6 mb-3">
                              <textarea
                                id="message"
                                name="message"
                                rows={5}
                                cols={60}
                                style={{ width: "100%" }}
                                placeholder="Agent Info"
                              ></textarea>
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-4">
                          <FormLabel
                            sx={{ color: " #38aecc", fontWeight: "bold" }}
                          >
                            Payment mode <span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Topup"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Payment Gateway"
                            />
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormLabel
                            sx={{ color: " #38aecc", fontWeight: "bold" }}
                          >
                            Product<span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Airline"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Hotel"
                            />
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormLabel
                            sx={{ color: " #38aecc", fontWeight: "bold" }}
                          >
                            Ticketing Features{" "}
                            <span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Allow FSC Hold Booking"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked
                                  sx={{
                                    color: "#4d3319",
                                    "&.Mui-checked": { color: "#4d3319" },
                                  }}
                                />
                              }
                              label="Allow Ticketing"
                            />
                          </FormGroup>
                        </div>
                      </div>

                      {/* <div className="row">
                        <div className="col-md-3">
                          <MuiSearchSelect
                            label="Airline Category"
                            placeholder="Airline Category"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-3">
                          <MuiSearchSelect
                            label="Airline Category"
                            placeholder="Airline Category"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>    
                      </div> */}

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <FormLabel
                            sx={{ color: " #38aecc", fontWeight: "bold" }}
                          >
                            Commission/Markup/Service Fee{" "}
                            <span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                            }}
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <MuiSearchSelect
                                  label="Airline Category"
                                  placeholder="Airline Category"
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-md-6">
                                <MuiSearchSelect
                                  label="Airline Category"
                                  placeholder="Airline Category"
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-6">
                          <FormLabel
                            sx={{ color: " #38aecc", fontWeight: "bold" }}
                          >
                            Additional Features{" "}
                            <span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                            }}
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <MuiInput
                                  placeholder="TDS(%)
  "
                                />
                              </div>
                              <div className="col-md-6">
                                <MuiInput
                                  placeholder="TDS(%)
  "
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>

                      <div className="pb-2 user-button w-full text-end onboard-btn">
                        <MuiButton
                          className="main-clear-btn"
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label="Create"
                          type="submit"
                          // disabled={!formik.dirty || !form/ik.isValid}
                          variant="outlined"
                          fullWidth={false}
                          className="main-btn"
                        />
                      </div>
                    </div>
                  )}

                  {!active && (
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Agent Name "}
                          label="Agent Name "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Status"} placeholder="Status" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Sales Incharge"}
                          label="Sales Incharge "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="Joined From Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="Joined To Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton className="clear-btn " label="Clear" />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Search"}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="overflow-auto">
                          <table className="min-w-full border text-sm">
                            <thead className="bg-gray-200 text-left">
                              <tr>
                                {[
                                  "Sl No",
                                  "Agent ID",
                                  "Agent Name",
                                  "Sales Person",
                                  "Landline No.",
                                  "Mobile No.",
                                  "Email ID",
                                  "Joined Date",
                                  "Updated By",
                                  "Balance",
                                  "Agent Type",
                                  "Action",
                                  "Status",
                                  "Welcome Mail",
                                ].map((header) => (
                                  <th
                                    key={header}
                                    className="px-4 py-2 border min-w-[150px]"
                                  >
                                    {header}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {agents.map((agent, index) => (
                                <tr key={index} className="hover:bg-gray-100">
                                  <td className="border px-4 py-2">
                                    {agent.slNo}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.agentId}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.agentName}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.salesPerson}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.landline}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.mobile}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.email}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.joinedDate}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.updatedBy}
                                  </td>
                                  <td className="border px-4 py-2 text-right">
                                    {agent.balance}
                                  </td>
                                  <td className="border px-4 py-2">
                                    {agent.agentType}
                                  </td>
                                  <td className="border px-4 py-2 text-blue-600 underline cursor-pointer">
                                    Edit
                                  </td>
                                  <td className="border px-4 py-2 text-green-600 underline cursor-pointer text-success">
                                    {agent.status}
                                  </td>
                                  <td className="border px-4 py-2 text-red-600 underline cursor-pointer text-warning">
                                    Send
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default AgentCreation;
